import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment.development';


@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private http = inject(HttpClient)
  private apiUrl = environment.apiUrl
  
  sendEmail(payload: object) {
    return this.http.post(`${this.apiUrl}/email`, payload, {responseType: 'text'})
  }
  
}
